import ResizeBar from './ResizeBar';

export default ResizeBar;
